(() => {
  'use strict';
  const canvas = document.querySelector('[data-neb-snow]');
  if (!canvas) return;
  const context = canvas.getContext('2d', { alpha: true });
  if (!context) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = matchMedia('(max-width: 767px)');
  const connection = navigator.connection;
  let paused = false;
  try { paused = sessionStorage.getItem('neb-snow-paused') === '1'; } catch (_) {}
  let width = 0;
  let height = 0;
  let flakes = [];
  let frame = 0;
  let lastPaint = 0;
  let ready = false;
  const eligible = () => !reduced.matches && !connection?.saveData;
  const stop = () => { cancelAnimationFrame(frame); frame = 0; lastPaint = 0; };
  const resize = () => {
    if (!eligible() || paused || document.hidden) return;
    width = innerWidth;
    height = innerHeight;
    const scale = Math.min(devicePixelRatio || 1, mobile.matches ? 1 : 1.25);
    canvas.width = Math.round(width * scale);
    canvas.height = Math.round(height * scale);
    context.setTransform(scale, 0, 0, scale, 0, 0);
    const count = mobile.matches ? 12 : 28;
    flakes = Array.from({ length: count }, () => ({ x: Math.random() * width, y: Math.random() * height, radius: .8 + Math.random() * 1.5, speed: 14 + Math.random() * 22, drift: -5 + Math.random() * 10, phase: Math.random() * Math.PI * 2 }));
  };
  const paint = time => {
    frame = 0;
    if (paused || !eligible() || document.hidden) return;
    if (time - lastPaint >= 1000 / 24) {
      const elapsed = lastPaint ? Math.min((time - lastPaint) / 1000, .1) : 1 / 24;
      lastPaint = time;
      context.clearRect(0, 0, width, height);
      context.shadowColor = 'rgba(70,105,123,.3)';
      context.shadowBlur = 2;
      context.fillStyle = 'rgba(255,255,255,.9)';
      flakes.forEach(flake => {
        flake.y += flake.speed * elapsed;
        flake.x += (flake.drift + Math.sin(time / 2100 + flake.phase) * 5) * elapsed;
        if (flake.y > height + 4) { flake.y = -4; flake.x = Math.random() * width; }
        if (flake.x < -4) flake.x = width + 4;
        if (flake.x > width + 4) flake.x = -4;
        context.beginPath();
        context.arc(flake.x, flake.y, flake.radius, 0, Math.PI * 2);
        context.fill();
      });
    }
    frame = requestAnimationFrame(paint);
  };
  const sync = () => {
    if (!ready) return;
    const enabled = eligible();
    document.querySelectorAll('[data-neb-snow-toggle]').forEach(button => {
      button.hidden = !enabled;
      button.setAttribute('aria-pressed', String(!paused));
      button.title = paused ? button.dataset.resumeLabel : button.dataset.pauseLabel;
    });
    canvas.hidden = !enabled || paused;
    if (!enabled || paused || document.hidden) {
      stop();
      if (!enabled || paused) { canvas.width = 1; canvas.height = 1; width = 0; height = 0; flakes = []; }
      return;
    }
    if (width !== innerWidth || height !== innerHeight || !flakes.length) resize();
    if (!frame) frame = requestAnimationFrame(paint);
  };
  const start = () => {
    ready = true;
    sync();
  };
  document.addEventListener('click', event => {
    if (!event.target.closest('[data-neb-snow-toggle]')) return;
    paused = !paused;
    try { sessionStorage.setItem('neb-snow-paused', paused ? '1' : '0'); } catch (_) {}
    sync();
  });
  addEventListener('resize', () => { if (ready) resize(); }, { passive: true });
  addEventListener('pagehide', stop);
  addEventListener('pageshow', sync);
  document.addEventListener('visibilitychange', sync);
  document.addEventListener('shopify:section:load', sync);
  reduced.addEventListener('change', sync);
  mobile.addEventListener('change', () => { if (ready) resize(); });
  connection?.addEventListener?.('change', sync);
  const schedule = () => {
    if ('requestIdleCallback' in window) requestIdleCallback(start, { timeout: 1500 });
    else setTimeout(start, 250);
  };
  if (document.readyState === 'complete') schedule();
  else addEventListener('load', schedule, { once: true });
})();
